export const customStyles = {
    option: (styles, {data, isDisabled, isFocused, isSelected}) => {
        const textColor = data.value === "delete" ? "#554DF1" : undefined

        return {
            ...styles,
            backgroundColor: isDisabled
                ? undefined
                : isSelected
                    ? "#554DF1"
                    : isFocused
                        ? `rgba(85, 77, 241, 0.1)`
                        : undefined,
            color: isDisabled
                ? "#ccc"
                : isSelected
                    ? "#fff"
                    : textColor || styles.color,
            cursor: isDisabled ? "not-allowed" : "default",
            ":active": {
                ...styles[":active"],
                backgroundColor: !isDisabled
                    ? isSelected
                        ? "#554DF1"
                        : `rgba(85, 77, 241, 0.3)`
                    : undefined,
            },
        }
    },
    menuList: (styles) => {
        return {
            ...styles,
            padding: 0,

        }
    }
}
